import { render, staticRenderFns } from "./association.vue?vue&type=template&id=25db179a&scoped=true&"
import script from "./association.vue?vue&type=script&lang=js&"
export * from "./association.vue?vue&type=script&lang=js&"
import style0 from "./association.vue?vue&type=style&index=0&id=25db179a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25db179a",
  null
  
)

export default component.exports